import { render, staticRenderFns } from "./MapiReservations.vue?vue&type=template&id=2a88e3b4&scoped=true&lang=pug&"
import script from "./MapiReservations.vue?vue&type=script&lang=js&"
export * from "./MapiReservations.vue?vue&type=script&lang=js&"
import style0 from "./MapiReservations.vue?vue&type=style&index=0&id=2a88e3b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88e3b4",
  null
  
)

export default component.exports